export default __webpack_public_path__ + "static/media/fasad13.dc4cd5f0.jpeg";